module.exports = __webpack_public_path__ + "img/northernmarianasislands.78c09eff.svg";